import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxDateBoxComponent } from 'devextreme-angular';
import { DatePickerService } from './date-picker.service';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    standalone: false
})
export class DatePickerComponent implements OnInit {
  dateBoxToolbarItems;
  @Input() acceptCustomValue: boolean = true;
  @Input() calendarOptions = {};
  @Input() dateSerializationFormat: string;
  @Input() disabled: boolean = false;
  @Input() displayFormat: string;
  @Input() id: string = 'dtbox';
  @Input() interval: Number = 30;
  @Input() invalidDateMessage: String = "Value must be a date or time";
  @Input() isRequiredValidator: boolean = false;
  @Input() max: Date | Number | String;
  @Input() min: Date | Number | String;
  @Input() pickerType: String;
  @Input() placeholder: string;
  @Input() readOnly: boolean = false;
  @Input() requiredValidationMessage: string = "This field is required";
  @Input() showClearButton: boolean = false;
  @Input() type: string = "date";
  @Input() value: Date | Number | String;
  @Input() width: number | string;
  @Output() onDatePickerFocusOut = new EventEmitter();
  @Output() onDatePickerKeyDown = new EventEmitter();
  @Output() onDatePickerValueChanged = new EventEmitter();
  @ViewChild('datebox', { static: false }) dateBox: DxDateBoxComponent;

  constructor(public datePickerService: DatePickerService) {
  }

  ngOnInit(): void {
    const that = this;
    this.dateBoxToolbarItems = [
      {
        toolbar: "bottom",
        widget: "dxButton",
        cssClass: 'date-picker-btn-secondary',
        options: {
          text: this.displayFormat=="monthAndYear" ? `Select "Current Month" (${this.datePickerService.getMonth()})` : `Select "Today" (${new Date().toLocaleDateString('en-GB')})`,
          onClick: function() {
            that.dateBox.instance.option("value", new Date());
            that.dateBox.instance.close();
          }
        }
      }
    ];
  }

  onDatePickerFocusOutEvent($event) {
    this.onDatePickerFocusOut.emit($event);
  }

  onDatedPickerValueChangedEvent($event) {
    this.onDatePickerValueChanged.emit($event);
  }

  onDatePickerKeyDownEvent($event) {
    this.onDatePickerKeyDown.emit($event);
  }

}
